export default {
	account_menu_status_label: 'Status',
	user_online_dialog_custom_status_message: 'Here you can enter a user defined status',
	user_online_status_picker_aria_label: 'Select user status',
	user_online_status_picker_current_aria_label: 'Current user status: {status}',
};
